import { render, staticRenderFns } from "./JobfairCreationGameSelect.vue?vue&type=template&id=bd2976f8&scoped=true"
import script from "./JobfairCreationGameSelect.vue?vue&type=script&lang=js"
export * from "./JobfairCreationGameSelect.vue?vue&type=script&lang=js"
import style0 from "./JobfairCreationGameSelect.vue?vue&type=style&index=0&id=bd2976f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2976f8",
  null
  
)

export default component.exports